export default __webpack_public_path__ + "static/sixer-logo-856ea52583ad55d52c828ec36381aa5e.svg";